import { render, staticRenderFns } from "./XlsxPreview.vue?vue&type=template&id=1f9c8085&scoped=true&"
import script from "./XlsxPreview.vue?vue&type=script&lang=js&"
export * from "./XlsxPreview.vue?vue&type=script&lang=js&"
import style0 from "./XlsxPreview.vue?vue&type=style&index=0&id=1f9c8085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c8085",
  null
  
)

export default component.exports